import React from 'react';
import './Pagination.css';

const Pagination = ({ 
    currentPage, 
    totalPages, 
    onChange 
}) => {
    if (totalPages <= 1) {
        return null;
    }

    const handlePrevious = () => {
        if (currentPage > 1) {
            onChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onChange(currentPage + 1);
        }
    };

    return (
        <div className="pagination">
            <button 
                onClick={handlePrevious} 
                disabled={currentPage === 1}
            >
                Previous
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button 
                onClick={handleNext} 
                disabled={currentPage === totalPages}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;
